/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { Button } from '@ui-elements';
import cn from 'classnames';
import { money } from '~/common/utils';
import { OfferListing } from '~/common/models';
import styles from './index.module.scss';
import { TooltipDisclaimer } from '~/common/components/ui-elements';
import { OfferSashContent } from '../offer-main-card/offerSashContent';
import { DeviceType } from '../offer-listing/offerDeviceType';
import { LegalDisclaimerContent } from '../offer-main-card/legalDisclaimerContent';

interface OfferTertiaryTileCardProps {
  offer: OfferListing;
  deviceType: DeviceType;
  isOneItemTile: boolean;
}

export const OfferTertiaryCard = ({
  offer,
  deviceType,
  isOneItemTile,
}: OfferTertiaryTileCardProps) => {
  const offerUrl = `/special-offers/${offer.uniqueName}`;
  const hasPrice = offer.price > 0;
  const preferredDevices: Array<string> =
    deviceType === 'mobile'
      ? ['tablet', 'desktop', 'mobile']
      : [deviceType, 'tablet', 'desktop', 'mobile'];

  const mediaForDevice =
    offer.media?.find((m) =>
      preferredDevices.some((d) => m.devices?.includes(d))
    ) || offer.media?.[0];
  const mediaThumbnail =
    offer.media?.find((m) => m.isThumbnail) || mediaForDevice;

  return (
    <div
      className={cn(styles.tertiaryTileCard, {
        [styles.oneTileLayout]: isOneItemTile,
      })}
      onClick={() => window.open(offerUrl, '_self')}
    >
      <div className={styles.imageWrapper}>
        <img src={mediaForDevice?.url || ''} alt={offer.title} />
        <OfferSashContent sash={offer.sash} />
        {mediaThumbnail && (
          <LegalDisclaimerContent
            disclaimer={mediaThumbnail}
            deviceType={deviceType}
          />
        )}
      </div>
      <div
        className={styles.content}
        style={{
          background: offer.contentColor?.contentBackgroundColor || 'inherit',
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            className={styles.offerTitle}
            style={{
              color: offer.contentColor?.contentTextColor || 'inherit',
            }}
          >
            <div
              className={styles.offerTitleText}
              dangerouslySetInnerHTML={{ __html: offer.title as string }}
            />
            {offer.titleDisclaimer && (
              <TooltipDisclaimer
                customContent
                disclaimer={offer.titleDisclaimer}
                triggerClassName={styles.disclaimerTrigger}
              />
            )}
          </div>

          {offer.blurb && (
            <div
              className={styles.blurb}
              style={{
                color: offer.contentColor?.contentTextColor || 'inherit',
              }}
              dangerouslySetInnerHTML={{ __html: offer.blurb }}
            />
          )}
        </div>
        {offer.contentCta?.text && (
          <Button
            type={offer.contentCta.variant || 'primary'}
            className={
              isOneItemTile && deviceType !== 'mobile'
                ? styles.ctaButton
                : undefined
            }
            buttonWidth={
              !isOneItemTile || deviceType === 'mobile'
                ? 'full-width'
                : undefined
            }
            href={offer.contentCta?.link}
          >
            {offer.contentCta?.text}
            {hasPrice && (
              <span>
                <sup>$</sup>
                <span>{money(offer.price).replace('$', '')}</span>
                <sup>*</sup>
              </span>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
